import { createSlice } from "@reduxjs/toolkit";

import {
  getMaintenanceDataAction,
  scheduleMaintenanceAction,
} from "@/redux/maintenance/actions";
import { initialState } from "@/redux/maintenance/initialState";
import type { MaintenanceTypes } from "@/redux/maintenance/maintenanceTypes";
import { maintenanceReducer } from "@/redux/maintenance/reducer";

export const maintenanceSlice = createSlice({
  name: "maintenance",
  reducers: maintenanceReducer,
  initialState,

  extraReducers: (builder) => {
    builder.addCase(
      getMaintenanceDataAction.pending,
      (state: MaintenanceTypes) => ({
        ...state,
      })
    );

    builder.addCase(
      getMaintenanceDataAction.fulfilled,
      (state: MaintenanceTypes, { payload }) => {
        const { success, status_code, message, result } = payload;

        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          isMaintenance: result?.under_maintenance,
          maintenanceData: result,
          success,
        };
      }
    );

    builder.addCase(
      getMaintenanceDataAction.rejected,
      (state: MaintenanceTypes, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      scheduleMaintenanceAction.pending,
      (state: MaintenanceTypes) => ({
        ...state,
      })
    );

    builder.addCase(
      scheduleMaintenanceAction.fulfilled,
      (state: MaintenanceTypes, { payload }) => {
        const { success, message, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            error: message,
          };
        }

        return {
          ...state,
          success,
          message,
          statusCode: status_code,
        };
      }
    );

    builder.addCase(
      scheduleMaintenanceAction.rejected,
      (state: MaintenanceTypes, { error }) => ({
        ...state,
        error: error?.message ?? null,
        success: 0,
      })
    );
  },
});

export const {
  resetIsMaintenance,
  resetMaintenanceError,
  resetMaintenanceSuccess,
  resetMaintenanceMessage,
  resetStatusCode,
} = maintenanceSlice.actions;
